module.exports = __webpack_public_path__ + "assets/img/Inter-Regular.svg?3fd9727c51f527fe32aad69b1ef9060c";